import { findDependents } from '@hc-frontend/business'
import { IMember } from '@hc-frontend/entities'
import { fetchJSON, getISODate } from '@hc-frontend/utils'
import { CRM_MIDDLEWARE } from 'core/constants/endpoints'
import { DependantResponse } from '../types'

function sendDependant(members: IMember[], leadId: string): Promise<DependantResponse> {
  const payload = {
    data: [],
    idLead: leadId
  }

  payload.data = findDependents(members).map(member => {
    const dFirstName = member.firstName || ''
    const dLastName = member.lastName || ''
    const dobDependant = getISODate(member.dob)

    return {
      fname: dFirstName,
      lname: dLastName,
      gender: member.gender,
      dob: dobDependant,
      applicant_type: member.type
    }
  })

  return fetchJSON<DependantResponse>(`${CRM_MIDDLEWARE}/dependant`, {
    body: payload
  }).then(response => response.parsedBody)
}

export { sendDependant }
